export default {
	methods: {
		arrayBufferToJson(arrayBuffer) {
			return JSON.stringify(Array.from(new Uint8Array(arrayBuffer)));
		},
		jsonToArrayBuffer(jsonStr) {
			return new Uint8Array(JSON.parse(jsonStr)).buffer;
		}
	}
};
